import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isBrowser: any;
  isServer: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private metaService: Meta
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
   
  }
  ngOnInit(): void {
    // if (this.isBrowser) {
    //   console.log('App loaded on browser!');
    // } else if (this.isServer) {
    //   console.log('App loaded on server!');
    // } else {
    //   console.log('App loaded!');
    // }
    // this.metaService.addTags([
    //   { name: 'title', content: '' },
    //   { name: 'description', content: '' },
    //   { name: 'url', content: '' },
    //   { property: 'og:title', content: '' },
    //   { property: 'og:description', content: '' },
    //   { property: 'og:type', content: 'website' },
    //   { property: 'og:url', content: '' },
    //   { property: 'og:image', content: '' },
    //   { property: 'og:image:secure_url', content: '', itemprop: 'image' },
    //   { property: 'og:image:type', content: 'image/png' },
    //   { property: 'og:image:width', content: '1200' },
    //   { property: 'og:image:height', content: '630' },
    //   { property: 'og:image:width', content: '300' },
    //   { property: 'og:image:height', content: '300' },
    //   { name: 'twitter:card', content: 'summary_large_image' },
    //   { name: 'twitter:title', content: '' },
    //   { name: 'twitter:description', content: '' },
    //   { name: 'twitter:url', content: '' },
    //   { name: 'twitter:image', content: '' },
    // ]);
  }
}
